import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from "react";
import Lottie from "lottie-react";
import animation from "./animation.json";
import mobile from "./mobile.json";
import styles from "./styles.module.css";
import { useScreenWidth } from "../SubscriptionPageV2/hooks";
const Animation = () => {
    const isMobile = useScreenWidth() < 999;
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (_jsx("div", { className: styles.container, children: _jsx(Lottie, { animationData: !isMobile ? animation : mobile, loop: true }) }));
};
export default Animation;
